import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TitularesService {

    constructor(private http:HttpClient) { }

    /*public totalServicios(titnit:number){
        return this.http.get(`${environment.api}titulares/totalServicios/${titnit}`);
    }*/

    public totalServiciosDocumento(titnit:number, historico:boolean){
        if(historico){
            return this.http.get(`${environment.api}titulares/totalServiciosDocumentoHistorico/${titnit}`);
        } else {
            return this.http.get(`${environment.api}titulares/totalServiciosDocumento/${titnit}`);
        }
    }

    public totalServiciosRadicado(grugru:number, historico:boolean){
        if(historico){
            return this.http.get(`${environment.api}titulares/totalServiciosRadicadoHistorico/${grugru}`);
        } else {
            return this.http.get(`${environment.api}titulares/totalServiciosRadicado/${grugru}`);
        }
    }

    public totalServiciosContrato(grugru:number, historico:boolean){
        if(historico){
            return this.http.get(`${environment.api}titulares/totalServiciosContratoHistorico/${grugru}`);
        } else {
            return this.http.get(`${environment.api}titulares/totalServiciosContrato/${grugru}`);
        }
    }

    public beneficiarios(titnit:number){
        return this.http.get(`${environment.api}titulares/beneficiarios/${titnit}`);
    }

    public beneficiariosContrato(ID_Grupo:number){
        return this.http.get(`${environment.api}titulares/beneficiariosContrato/${ID_Grupo}`);
    }


}
